import { classNames } from 'primereact/utils';
import {
  DialogPassThroughOptions,
  DialogProps,
  DialogState,
} from 'primereact/dialog';

export const PTDialog: DialogPassThroughOptions = {
  root: ({ state, props }: { state: DialogState; props: DialogProps }) => ({
    className: classNames(
      'ax-dialog',
      'max-h-[90%] transform scale-100',
      {
        'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0':
          state.maximized,
      },
      {
        'ax-dialog-top': props.position === 'top',
        'ax-dialog-left': props.position === 'left',
        'ax-dialog-right': props.position === 'right',
        'ax-dialog-bottom': props.position === 'bottom',
        'ax-dialog-bottom-right': props.position === 'bottom-right',
        'ax-dialog-bottom-left': props.position === 'bottom-left',
        'ax-dialog-top-right': props.position === 'top-right',
        'ax-dialog-top-left': props.position === 'top-left',
      },
    ),
  }),
  header: {
    className: classNames(
      'flex items-start justify-between shrink-0',
      'relative',
      'border-t-0  rounded-t-lg',
    ),
  },
  headerTitle: ({ props }: { props: DialogProps }) => ({
    className: classNames('max-w-[90%]', {
      'font-medium ax-dialog__title pb-4': props.header,
    }),
  }),
  headerIcons: 'flex items-start ax-dialog__icons' as any,
  closeButton: {
    className: classNames(
      'ax-dialog__icons__close flex items-center justify-center overflow-hidden relative',
      'w-8 h-8 border-0 bg-transparent rounded-full transition duration-200 ease-in-out mr-2 last:mr-0',
      'hover:border-transparent',
      'focus:outline-none focus:outline-offset-0',
    ),
  },
  closeButtonIcon:
    'w-4 h-4 inline-block text-red cursor-pointer hover:text-black' as any,
  content: ({ state, props }: any) => ({
    className: classNames(
      'ax-scrollbar',
      'overflow-y-auto',
      'ax-dialog-padding pt-0',
      { 'rounded-b-lg': !props.footer },
      {
        grow: state.maximized,
      },
    ),
  }),
  footer: {
    className: classNames(
      'shrink-0 ax-dialog-padding',
      'border-t-0 text-right rounded-b-lg',
    ),
  },
  transition: {
    enter: true,
    exit: true,
    classNames: {
      enter: 'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0',
      enterActive: 'transition-all duration-200 ease-out',
      exit: 'transition-all duration-200 ease-out',
      exitActive:
        'opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0',
    },
    timeout: { enter: 50, exit: 50 },
  },

  mask: ({ state }: any) => ({
    className: classNames(
      'fixed inset-0 z-[1101] flex items-center justify-center bg-white/40 backdrop-blur-sm',
      'transition-opacity duration-300 ease-in-out',
      {
        'opacity-100': state.containerVisible,
        'opacity-0': !state.containerVisible,
      },
    ),
  }),
};
